export const validatePhone = (phone?: string) => {
  if (!phone) {
    return false;
  }
  const isUkrainPhone = phone.startsWith('380');

  return isUkrainPhone ? /^380\d{9}$/.test(phone) : phone.length > 5;
};
